export enum ImpresosEnum {
    printInvoice = 'printInvoice',
    printInvoiceReceipt = 'printInvoiceReceipt',
    printPresupuestoTaller = 'printPresupuestoTaller',
    printValoracion = 'printValoracion',
    printGaranteeManualComp = 'printGaranteeManualComp',
    printGaranteeClient = 'printGaranteeClient',
    printGaranteeIntern = 'printGaranteeIntern',
    printGroupingInvoices = 'printGroupingInvoices',
    printInvoiceGroupingDetail = 'printInvoiceGroupingDetail',
    printInvoiceGroupingResumen = 'printInvoiceGroupingResumen',
    printPresupuestoOR = 'printPresupuestoOR',
    printReceivedInvoice = 'printReceivedInvoice',
    printInvoicePurchase = 'printInvoicePurchase',
    printPartsInvoice = 'printPartsInvoice',
    printVOinvoices = 'printVOinvoices',
    printVOProforma = 'printVOProforma',
    printNote = 'printNote',
    printInvoicePreview = 'printInvoicePreview',
    printFichajes = 'printFichajes',
    printBonoPicajes = 'printBonoPicajes',
    printCarHistory = 'printCarHistory',
    printBajaMasiva = 'printBajaMasiva',
    printCorreccion = 'printCorreccion',
    printAlmacen = 'printAlmacen',
    printPedido = 'printPedido',
    printTomaInventario = 'printTomaInventario',
    printDiferenciasInventario = 'printDiferenciasInventario',
    printValoradoInventario = 'printValoradoInventario',
    printPayment = 'printPayment',
    printPurchasePayment = 'printPurchasePayment',
    printReportSendGarantee = 'printReportSendGarantee',
    printReportSendGaranteeSG = 'printReportSendGaranteeSG',
    printAccountingConfig = 'printAccountingConfig',
    printAccountEntryValid = 'printAccountEntryValid',
    printAccountEntryError = 'printAccountEntryError',
    printAccountInvoiceNoExport = 'printAccountInvoiceNoExport',
    printMarketing = 'printMarketing',
    receipt = 'receipt',
    printAppointmentsList = 'printAppointmentsList',
    printAppointmentConfirmation = 'printAppointmentConfirmation',
    printHistorial = 'printHistorial',
    printPresupuestoVM = 'printPresupuestoVM',
    printAlbaran = 'printAlbaran',
    printAnulacionAlbaran = 'printAnulacionAlbaran',
    printInvoiceGroupingValoration = 'printInvoiceGroupingValoration',
    printVOTransfer = 'printVOTransfer',
    printCourtesyVehicleAgreement = 'printCourtesyVehicleAgreement',
    printWarrantyIncident = 'printWarrantyIncident',
    printLegalConditions = 'printLegalConditions',
    or = 'or',
    bonosPicajes = 'printBonoPicajes',
    valet = 'printValet',
    printConsentimientos = 'printPrivacyStatement'
}

